import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('davy_jones', {
  cherry: 'skull',
  lemon: 'crossbones',
  orange: 'cursed_coin',
  bell: 'hook',
  star: 'davy_jones_wild',
  seven: 'cutlass',
  gem: 'cursed_amethyst',
  scatter: 'ghost_ship_scatter',
  money: 'cursed_hoard',
});

/** Davy Jones — GENERATED by scaffoldSlot from
 *  content/slots/davy_jones.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const DAVY_JONES_THEME: Theme = {
  id: 'davy_jones',
  name: 'Davy Jones',
  palette: {
    accent: 0x3fb58c,
    secondary: 0x6e7a82,
    warm: 0xe6c878,
    frameFill: 0x10211e,
    bgGradientTop: 0x183029,
    bgGradientBottom: 0x08140f,
    dimOverlay: 0x040a08,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Skull', glyph: '💀', tint: 0xe8e2d0, weight: 5, textureAlias: 'davy_jones:cherry',
        winVideoAlias: 'davy_jones:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Crossbones', glyph: '🦴', tint: 0xe8e2d0, weight: 5, textureAlias: 'davy_jones:lemon',
        winVideoAlias: 'davy_jones:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Cursed Coin', glyph: '🪙', tint: 0xc89a52, weight: 4, textureAlias: 'davy_jones:orange',
        winVideoAlias: 'davy_jones:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Hook', glyph: '🪝', tint: 0xb8bcc2, weight: 3, textureAlias: 'davy_jones:bell',
        winVideoAlias: 'davy_jones:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Davy Jones', glyph: '👻', tint: 0x3fb58c, weight: 2, textureAlias: 'davy_jones:star',
        winVideoAlias: 'davy_jones:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Cutlass', glyph: '🗡️', tint: 0xc4c8ce, weight: 2, textureAlias: 'davy_jones:seven',
        winVideoAlias: 'davy_jones:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Cursed Amethyst', glyph: '🔮', tint: 0x9a5ec8, weight: 2.5, textureAlias: 'davy_jones:gem',
        winVideoAlias: 'davy_jones:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Ghost Ship', glyph: '🚢', tint: 0x3fb58c, weight: 0.5, textureAlias: 'davy_jones:scatter',
        winVideoAlias: 'davy_jones:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Cursed Hoard', glyph: '💰', tint: 0xe6c878, weight: 1, textureAlias: 'davy_jones:money',
        winVideoAlias: 'davy_jones:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x10211e, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x3fb58c, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xe6c878, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x10211e, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x6e7a82, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x3fb58c, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xe6c878, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x10211e, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xe6c878, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x3fb58c, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xe6c878, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xe6c878, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'davy_jones:bg', path: 'environment/davy_jones.png' },
      columnBackground: { alias: 'davy_jones:column_bg', path: 'reel/davy_jones_column_bg.png' },
      border: { alias: 'davy_jones:border', path: 'brand/border_underwater.png' },
    },
  },
};
